import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import localeData from 'dayjs/plugin/localeData';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import { Configs } from 'constants/app/configs';

export const dayjsConfig = () => {
  dayjs.extend(utc);
  dayjs.extend(weekday);
  dayjs.extend(isoWeek);
  dayjs.extend(localeData);
  const { LANGUAGE: lang } = Configs;

  import(
    /* webpackChunkName: "dayjs-locale-[request]" */ `dayjs/locale/${lang}.js`
  ).then(() => {
    dayjs.locale(lang);
  });
};
